var map = {
	"./0100/16x9/06.jpg": "AXPN",
	"./0100/21x9/06.jpg": "VaUM",
	"./0100/3x2/06.jpg": "2Tr6",
	"./0100/4x1/06.jpg": "CXon",
	"./0100/4x3/06.jpg": "4BS5",
	"./0480/4x3/06.jpg": "CQR/",
	"./0600/3x4/06.jpg": "CBv/",
	"./0800/3x2/06.jpg": "j9RU",
	"./1200/16x9/06.jpg": "UIwU",
	"./1440/21x9/06.jpg": "Kfdu",
	"./1920/4x1/06.jpg": "fY/q"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "FvJW";